import { EnrichedIssueEntity } from 'types/IssueEntity'
import { getCommitmentsInPercentage, getIssueSubscriptionQuota } from '../../issues/utils'
import { startOfDay } from 'date-fns'

export const exportDataGridProps = {
    showToolbar: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    slotProps: {
        toolbar: { showQuickFilter: false, csvOptions: { utf8WithBom: true, delimiter: ';' } },
    },
} as const

export const getCommitmentForLatestIssuesAtDate = (
    issues: Pick<EnrichedIssueEntity, 'publicationDate' | 'noInvestorsNamed' | 'investors'>[],
    dates: Date[],
) => {
    const maxDate = dates.reduce(function (a, b) {
        return a > b ? a : b
    })
    const getFilter =
        (d: Date) => (i: Pick<EnrichedIssueEntity, 'publicationDate' | 'noInvestorsNamed' | 'investors'>) =>
            i.publicationDate !== null &&
            new Date(i.publicationDate) < startOfDay(d) &&
            (i.noInvestorsNamed || i.investors.length > 0)
    const filtered = issues.filter(getFilter(maxDate))
    const sorted = filtered.sort(
        (a, b) => new Date(b.publicationDate as string).getTime() - new Date(a.publicationDate as string).getTime(),
    )

    return dates.map((d) =>
        sorted
            .filter(getFilter(d))
            .slice(0, 20)
            .reduce((acc, issue, index, arr) => {
                const { totalCommitment = null } = getCommitmentsInPercentage(issue) || {}

                if (totalCommitment === null) return acc

                return acc + Math.min(100, totalCommitment) / arr.length
            }, 0),
    )
}

export const getCommitmentExclGuarantorsForLatestIssuesAtDate = (
    issues: Pick<EnrichedIssueEntity, 'subEndDate' | 'unitSubTotal' | 'secondarySub' | 'totalOfferedUnits'>[],
    dates: Date[],
) => {
    const sorted = issues.sort(
        (a, b) => new Date(b.subEndDate as string).getTime() - new Date(a.subEndDate as string).getTime(),
    )
    return dates.map((d) =>
        sorted
            .filter(
                (i) =>
                    i.subEndDate !== null &&
                    new Date(i.subEndDate) < startOfDay(d) &&
                    (i.unitSubTotal !== null || i.secondarySub !== null),
            )

            .slice(0, 20)
            .reduce((acc, issue) => {
                const commitmentExclGuarantors = getIssueSubscriptionQuota(issue)
                return acc + (commitmentExclGuarantors ?? 0) / 20
            }, 0),
    )
}
